import { render, staticRenderFns } from "./EventPage.vue?vue&type=template&id=e6d41816&"
import script from "./EventPage.vue?vue&type=script&lang=ts&"
export * from "./EventPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports